import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const AAHASimple = forwardRef<SVGSVGElement, SvgIconProps>(
  function AAHASimple(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path
          d="M10,0 L12.8088361,4.91443345 C16.6312153,6.05250108 19.4955692,9.4145458 19.9012295,13.4998991 L16.8797247,13.4999918 C16.3944915,10.1077016 13.4770838,7.5 9.95061474,7.5 C6.42414568,7.5 3.50673797,10.1077016 3.02150477,13.4999918 L5.6896955e-14,13.4998991 C0.409903559,9.37181198 3.33020696,5.98224456 7.21265526,4.87945177 L10,0 Z"
          transform="translate(2.5, 4)"
        />
      </SvgIcon>
    )
  },
)

export default AAHASimple
